import * as Yup from "yup";

export const liveCallManualTaskCompleteSchema = Yup.object().shape({
  completionDate: Yup.string().label("Date & Time").required(),
  reason: Yup.string()
    .label("Follow-up notes")
    .required("Follow-up notes are required.")
    .max(500, "Follow-up notes can have maximum 500 characters."),
});
